// extracted by mini-css-extract-plugin
export default {"accessButton":"BankDialog_accessButton__DVJ9+","bankDiv":"BankDialog_bankDiv__bBH3P"};